module.exports = __webpack_public_path__ + "static/1024-rou-432bce68029a53eb00bedb92359983a8.png";